import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCsvIconLarge = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 47 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_dd_13724_91499)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M5 5C5 2.79086 6.79086 1 9 1H28L41.8 14.8V43C41.8 45.2091 40.0091 47 37.8 47H8.99999C6.79086 47 5 45.2091 5 43V5Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M9 1.34961H27.8555L41.4502 14.9443V43C41.4502 45.0158 39.8156 46.6504 37.7998 46.6504H9C6.98416 46.6504 5.34961 45.0158 5.34961 43V5C5.34961 2.98416 6.98416 1.34961 9 1.34961Z",
				stroke: "#A4A7AE",
				strokeWidth: .7
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter1_d_13724_91499)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M28 1L41.8 14.8H32C29.7909 14.8 28 13.0091 28 10.8V1Z",
				fill: "#FDFDFD"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M41.1963 14.5498H32C29.9289 14.5498 28.25 12.8709 28.25 10.7998V1.60352L41.1963 14.5498Z",
				stroke: "#A4A7AE",
				strokeWidth: .5
			})]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10.434,
			y: 18.2973,
			width: 24.7211,
			height: 22.3,
			rx: 1.65,
			stroke: "#D5D7DA",
			strokeWidth: .7
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 11.2949,
			y1: 26.0711,
			x2: 35.5054,
			y2: 26.0711,
			stroke: "#D5D7DA",
			strokeWidth: .7
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 11.2949,
			y1: 33.3343,
			x2: 35.5054,
			y2: 33.3343,
			stroke: "#D5D7DA",
			strokeWidth: .7
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 10.584,
			y1: 6.55273,
			x2: 21.6892,
			y2: 6.55273,
			stroke: "#D5D7DA",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 10.584,
			y1: 10.1843,
			x2: 15.6366,
			y2: 10.1843,
			stroke: "#D5D7DA",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 17.6977,
			y1: 17.9473,
			x2: 17.6977,
			y2: 40.9473,
			stroke: "#D5D7DA",
			strokeWidth: .7
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1.61133,
			y: 24,
			width: 25.4211,
			height: 12.1053,
			rx: 2,
			fill: "url(#paint0_linear_13724_91499)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1.61133,
			y: 24,
			width: 25.4211,
			height: 12.1053,
			rx: 2,
			stroke: "#A0A0A0",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.6294 29.2188H10.3851C10.3624 29.0578 10.316 28.9148 10.2459 28.7898C10.1758 28.6629 10.0859 28.5549 9.97603 28.4659C9.86618 28.3769 9.73929 28.3087 9.59535 28.2614C9.4533 28.214 9.29895 28.1903 9.13228 28.1903C8.83114 28.1903 8.56883 28.2652 8.34535 28.4148C8.12186 28.5625 7.94857 28.7784 7.82546 29.0625C7.70236 29.3447 7.6408 29.6875 7.6408 30.0909C7.6408 30.5057 7.70236 30.8542 7.82546 31.1364C7.95046 31.4186 8.1247 31.6316 8.34819 31.7756C8.57167 31.9195 8.8302 31.9915 9.12376 31.9915C9.28853 31.9915 9.44099 31.9697 9.58114 31.9261C9.72319 31.8826 9.84914 31.8191 9.95898 31.7358C10.0688 31.6506 10.1597 31.5473 10.2317 31.4261C10.3056 31.3049 10.3567 31.1667 10.3851 31.0114L11.6294 31.017C11.5972 31.2841 11.5167 31.5417 11.388 31.7898C11.2611 32.036 11.0897 32.2566 10.8738 32.4517C10.6597 32.6449 10.4041 32.7983 10.1067 32.9119C9.81126 33.0237 9.47698 33.0795 9.10387 33.0795C8.58493 33.0795 8.12092 32.9621 7.71183 32.7273C7.30463 32.4924 6.98266 32.1525 6.74592 31.7074C6.51107 31.2623 6.39364 30.7235 6.39364 30.0909C6.39364 29.4564 6.51296 28.9167 6.7516 28.4716C6.99023 28.0265 7.3141 27.6875 7.72319 27.4545C8.13228 27.2197 8.59251 27.1023 9.10387 27.1023C9.44099 27.1023 9.75349 27.1496 10.0414 27.2443C10.3311 27.339 10.5878 27.4773 10.8113 27.6591C11.0347 27.839 11.2166 28.0597 11.3567 28.321C11.4988 28.5824 11.5897 28.8816 11.6294 29.2188ZM15.6678 28.8551C15.6451 28.6259 15.5475 28.4479 15.3752 28.321C15.2028 28.1941 14.9689 28.1307 14.6735 28.1307C14.4727 28.1307 14.3032 28.1591 14.165 28.2159C14.0267 28.2708 13.9206 28.3475 13.8468 28.446C13.7748 28.5445 13.7388 28.6562 13.7388 28.7812C13.735 28.8854 13.7568 28.9763 13.8042 29.054C13.8534 29.1316 13.9206 29.1989 14.0059 29.2557C14.0911 29.3106 14.1896 29.3589 14.3013 29.4006C14.4131 29.4403 14.5324 29.4744 14.6593 29.5028L15.182 29.6278C15.4358 29.6847 15.6687 29.7604 15.8809 29.8551C16.093 29.9498 16.2767 30.0663 16.432 30.2045C16.5873 30.3428 16.7076 30.5057 16.7928 30.6932C16.8799 30.8807 16.9244 31.0956 16.9263 31.3381C16.9244 31.6941 16.8335 32.0028 16.6536 32.2642C16.4756 32.5237 16.218 32.7254 15.8809 32.8693C15.5456 33.0114 15.1413 33.0824 14.6678 33.0824C14.1981 33.0824 13.789 33.0104 13.4405 32.8665C13.0939 32.7225 12.8231 32.5095 12.628 32.2273C12.4348 31.9432 12.3335 31.5919 12.324 31.1733H13.5144C13.5276 31.3684 13.5835 31.5312 13.682 31.6619C13.7824 31.7907 13.9159 31.8883 14.0826 31.9545C14.2511 32.0189 14.4415 32.0511 14.6536 32.0511C14.8619 32.0511 15.0428 32.0208 15.1962 31.9602C15.3515 31.8996 15.4718 31.8153 15.557 31.7074C15.6422 31.5994 15.6848 31.4754 15.6848 31.3352C15.6848 31.2045 15.646 31.0947 15.5684 31.0057C15.4926 30.9167 15.3809 30.8409 15.2331 30.7784C15.0873 30.7159 14.9083 30.6591 14.6962 30.608L14.0627 30.4489C13.5721 30.3295 13.1848 30.143 12.9007 29.8892C12.6167 29.6354 12.4756 29.2936 12.4775 28.8636C12.4756 28.5114 12.5693 28.2036 12.7587 27.9403C12.95 27.6771 13.2123 27.4716 13.5456 27.3239C13.879 27.1761 14.2578 27.1023 14.682 27.1023C15.1138 27.1023 15.4907 27.1761 15.8127 27.3239C16.1365 27.4716 16.3884 27.6771 16.5684 27.9403C16.7483 28.2036 16.8411 28.5085 16.8468 28.8551H15.6678ZM18.8049 27.1818L20.2111 31.6023H20.2651L21.6742 27.1818H23.0378L21.0321 33H19.4469L17.4384 27.1818H18.8049Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_dd_13724_91499",
				x: 0,
				y: 0,
				width: 46.7998,
				height: 56,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 2,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect1_dropShadow_13724_91499"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.06 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_13724_91499"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 1,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect2_dropShadow_13724_91499"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_13724_91499",
						result: "effect2_dropShadow_13724_91499"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_13724_91499",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_13724_91499",
				x: 26,
				y: 0,
				width: 17.7998,
				height: 17.8,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_13724_91499"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_13724_91499",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_13724_91499",
				x1: 14.3219,
				y1: 24,
				x2: 14.3219,
				y2: 36.1053,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#BBBBBB" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ADADAD"
				})]
			})
		] })
	]
});
export default SvgCsvIconLarge;
